export default __webpack_public_path__ + "static/media/comprehension-quizze.06894f15.svg";